// import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
// import { toast } from 'react-toastify'
// import { setChangePassAndTxn, setLoader } from '../redux/actions/common/commonSlice'
// import { logout } from '../redux/actions/login/loginSlice'
// import { store } from '../redux/store'
// import authService from '../services/auth.service'

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASEURL,
//   timeout: 50000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

// api.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     //store.dispatch(setLoader(true))
//     // Do something before request is sent
//     const token = authService.getToken()
//     config.headers.Authorization = token ? `Bearer ${token}` : ''
//     return config
//   },
//   (error: AxiosError) => {
//     // Do something with request error
//     return Promise.reject(error)
//   },
// )

// // Add a response interceptor to handle 401 errors globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Handle JWT expiration and redirect to appropriate login page
//     if (error.response?.status === 401) {
//       console.log('Unauthorized request - JWT expired:', error.config?.url)
      
//       // ✅ FIX: Redirect to appropriate login page based on current path
//       const currentPath = window.location.pathname
//       const isAdminPath = currentPath.startsWith('/admin')
      
//       // Clear auth data (both user and admin tokens)
//       localStorage.removeItem('token')
//       localStorage.removeItem('refreshToken')
//       localStorage.removeItem('token-admin')
//       localStorage.removeItem('refreshToken-admin')
      
//       // Redirect to appropriate login page
//       if (isAdminPath) {
//         console.log('🔄 Redirecting to admin login')
//         window.location.href = '/admin/login'
//       } else {
//         console.log('🔄 Redirecting to user login')
//         window.location.href = '/login'
//       }
      
//       // Silently reject without throwing to prevent uncaught promise errors
//       return Promise.reject(error)
//     }
//     return Promise.reject(error)
//   }
// )

// // Add a global error handler for uncaught promise rejections
// if (typeof window !== 'undefined') {
//   window.addEventListener('unhandledrejection', (event) => {
//     // Check if it's a network error we want to suppress
//     if (event.reason?.message?.includes('401') || 
//         event.reason?.message?.includes('Network Error') ||
//         event.reason?.response?.status === 401) {
//       console.log('Suppressed uncaught promise rejection:', event.reason.message)
//       event.preventDefault() // Prevent the error from showing in console
//     }
//   })
// }

// export const sportsApi = axios.create({
//   baseURL: process.env.REACT_APP_API_SPORTS_URL,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

// export const fancyApi = axios.create({
//   baseURL: process.env.REACT_APP_PYTHON_SERVER,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })
// fancyApi.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     store.dispatch(setLoader(true))
//     // Do something before request is sent
//     const token = authService.getToken()
//     config.headers.Authorization = token ? `Bearer ${token}` : ''
//     return config
//   },
//   (error: AxiosError) => {
//     // Do something with request error
//     return Promise.reject(error)
//   },
// )

// // Add a response interceptor
// fancyApi.interceptors.response.use(
//   (response: AxiosResponse) => {
//     store.dispatch(setLoader(false))
//     if (!response.data.changePassAndTxn) {
//       store.dispatch(setChangePassAndTxn(response.data.changePassAndTxn))
//     }

//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response
//   },
//   async (error: AxiosError<{ message: string; data: any }>) => {
//     store.dispatch(setLoader(false))
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     const token = authService.getRefreshToken()
//     const originalConfig: any = error.config

//     if (error.response?.data?.data && error.response?.data?.data.maintenance) {
//       setTimeout(() => {
//         store.dispatch(logout())
//         window.location.reload()
//       }, 1)
//     }

//     if (
//       (error.response?.status === 401 && error.response?.data?.message === 'jwt expired') ||
//       (error.response?.data?.message === 'jwt malformed' && !originalConfig._retry)
//     ) {
//       // ✅ FIX: Handle JWT expiration with proper redirection
//       console.log('🔄 JWT expired - redirecting to login')
      
//       // Dispatch logout action
//       store.dispatch(logout())
      
//       // Clear auth data
//       localStorage.removeItem('token')
//       localStorage.removeItem('refreshToken')
      
//       // Redirect to appropriate login page based on current path
//       const currentPath = window.location.pathname
//       const isAdminPath = currentPath.startsWith('/admin')
      
//       if (isAdminPath) {
//         window.location.href = '/admin/login'
//       } else {
//         window.location.href = '/login'
//       }
      
//       return true
//     }

//     if (error.response?.data?.message !== 'No auth token') {
//       if (!window.location.pathname.includes('/login')) toast.error(error.response?.data?.message)
//     }

//     return Promise.reject(error)
//   },
// )

// export default api


// import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
// import { toast } from 'react-toastify'
// import { setChangePassAndTxn, setLoader } from '../redux/actions/common/commonSlice'
// import { logout } from '../redux/actions/login/loginSlice'
// import { store } from '../redux/store'
// import authService from '../services/auth.service'

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASEURL,
//   timeout: 50000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

// api.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     // Only add Authorization for non-OTP endpoints and non-register2 endpoint
//     if (
//       !config.url?.includes('/send-otp') &&
//       !config.url?.includes('/verify-otp') &&
//       !config.url?.includes('/signup-with-otp') &&
//       !config.url?.includes('/register2') &&
//       !config.url?.includes('/update-password') // <-- Do not overwrite for update-password
//     ) {
//       const token = authService.getToken()
//       config.headers.Authorization = token ? `Bearer ${token}` : ''
//     }
//     // Do NOT delete Authorization header in else block, so custom headers are preserved
//     return config
//   },
//   (error: AxiosError) => {
//     // Do something with request error
//     return Promise.reject(error)
//   },
// )

// // Add a response interceptor
// api.interceptors.response.use(
//   (response: AxiosResponse) => {
//     store.dispatch(setLoader(false))
//     if (!response.data.changePassAndTxn) {
//       store.dispatch(setChangePassAndTxn(response.data.changePassAndTxn))
//     }

//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response
//   },
//   async (error: AxiosError<{ message: string; data: any }>) => {
//     store.dispatch(setLoader(false))
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     const token = authService.getRefreshToken()
//     const originalConfig: any = error.config

//     if (error.response?.data?.data && error.response?.data?.data.maintenance) {
//       setTimeout(() => {
//         store.dispatch(logout())
//         window.location.reload()
//       }, 1)
//     }

//     if (
//       (error.response?.status === 401 && error.response?.data?.message === 'jwt expired') ||
//       (error.response?.data?.message === 'jwt malformed' && !originalConfig._retry)
//     ) {
//       // const refreshTokenApi = await authService.refreshToken(token)
//       // const accessToken = refreshTokenApi.data.data.newToken
//       // originalConfig._retry = true
//       // api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
//       // localStorage.setItem('token', accessToken)
//       // return api(originalConfig)
//       store.dispatch(logout())
//       window.location.reload()
//       return true
//     }

//     if (error.response?.data?.message !== 'No auth token') {
//       if (!window.location.pathname.includes('/login')) toast.error(error.response?.data?.message)
//     }

//     return Promise.reject(error)
//   },
// )

// export const sportsApi = axios.create({
//   baseURL: process.env.REACT_APP_API_SPORTS_URL,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

// export const fancyApi = axios.create({
//   baseURL: process.env.REACT_APP_PYTHON_SERVER,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })
// fancyApi.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     store.dispatch(setLoader(true))
//     // Do something before request is sent
//     const token = authService.getToken()
//     config.headers.Authorization = token ? `Bearer ${token}` : ''
//     return config
//   },
//   (error: AxiosError) => {
//     // Do something with request error
//     return Promise.reject(error)
//   },
// )

// // Add a response interceptor
// fancyApi.interceptors.response.use(
//   (response: AxiosResponse) => {
//     store.dispatch(setLoader(false))
//     if (!response.data.changePassAndTxn) {
//       store.dispatch(setChangePassAndTxn(response.data.changePassAndTxn))
//     }

//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response
//   },
//   async (error: AxiosError<{ message: string; data: any }>) => {
//     store.dispatch(setLoader(false))
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     const token = authService.getRefreshToken()
//     const originalConfig: any = error.config

//     if (error.response?.data?.data && error.response?.data?.data.maintenance) {
//       setTimeout(() => {
//         store.dispatch(logout())
//         window.location.reload()
//       }, 1)
//     }

//     if (
//       (error.response?.status === 401 && error.response?.data?.message === 'jwt expired') ||
//       (error.response?.data?.message === 'jwt malformed' && !originalConfig._retry)
//     ) {
//       // const refreshTokenApi = await authService.refreshToken(token)
//       // const accessToken = refreshTokenApi.data.data.newToken
//       // originalConfig._retry = true
//       // api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
//       // localStorage.setItem('token', accessToken)
//       // return api(originalConfig)
//       store.dispatch(logout())
//       window.location.reload()
//       return true
//     }

//     if (error.response?.data?.message !== 'No auth token') {
//       if (!window.location.pathname.includes('/login')) toast.error(error.response?.data?.message)
//     }

//     return Promise.reject(error)
//   },
// )

// export default api










import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

import { notifyError } from './appToast'

import { setChangePassAndTxn, setLoader } from '../redux/actions/common/commonSlice'

import { logout } from '../redux/actions/login/loginSlice'

import { store } from '../redux/store'

import authService from '../services/auth.service'



const api = axios.create({

  baseURL: process.env.REACT_APP_API_BASEURL,

  timeout: 50000,

  headers: {

    'Content-Type': 'application/json',

  },

})



// ✅ REQUEST INTERCEPTOR
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Endpoints that do NOT require Authorization (only OTP and register2)
    const noAuthEndpoints = [
      '/send-otp',
      '/verify-otp',
      '/register2'
      // ✅ REMOVED '/update-password' - it now requires JWT authentication
    ];

    // Check if current request matches any no-auth endpoint
    const isNoAuth = noAuthEndpoints.some(endpoint =>
      config.url?.includes(endpoint)
    );

    // Add Authorization header for all endpoints EXCEPT noAuthEndpoints
    if (!isNoAuth) {
      const token = authService.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // 🔒 AUTO-ADD BETCODE to deposit/withdraw requests
    if (config.url?.includes('add-deposit-withdraw') && config.data) {
      const BETCODE = process.env.REACT_APP_BETCODE || 'Yasfdgyys35466';
      
      // For FormData (file upload), append betcode
      if (config.data instanceof FormData) {
        config.data.append('betcode', BETCODE);
        console.log('✅ Betcode added to deposit/withdraw request (FormData)');
      } 
      // For regular JSON data, add betcode
      else if (typeof config.data === 'object') {
        config.data = { ...config.data, betcode: BETCODE };
        console.log('✅ Betcode added to deposit/withdraw request (JSON)');
      }
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// ✅ RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response: AxiosResponse) => {
    // Stop loader on successful response
    store.dispatch(setLoader(false));

    // Update changePassAndTxn if available
    if (!response.data.changePassAndTxn) {
      store.dispatch(setChangePassAndTxn(response.data.changePassAndTxn));
    }

    // ✅ CHECK FOR SESSION CONFLICT IN 200 RESPONSES
    if (response.data?.sessionConflict || response.data?.error === 'SESSION_CONFLICT') {
      console.log('🔒 Session conflict detected - Session already active on another device');
      
      // ✅ DON'T show any message - silent logout
      
      // Clear all auth data from BOTH localStorage AND sessionStorage
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('token-admin');
      localStorage.removeItem('refreshToken-admin');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('token-admin');
      sessionStorage.removeItem('refreshToken-admin');
      
      // Dispatch logout
      store.dispatch(logout());
      
      // Redirect to login after a short delay
      setTimeout(() => {
        const currentPath = window.location.pathname;
        const isAdminPath = currentPath.startsWith('/admin');
        
        if (isAdminPath) {
          window.location.href = '/admin/login';
        } else {
          window.location.href = '/login';
        }
      }, 1000);
      
      // Return response to prevent further processing
      return response;
    }

    return response;
  },
  async (error: AxiosError<{ message: string; data: any }>) => {
    store.dispatch(setLoader(false));

    const token = authService.getRefreshToken();
    const originalConfig: any = error.config;

    // Maintenance Mode Handling
    if (error.response?.data?.data && error.response?.data?.data.maintenance) {
      setTimeout(() => {
        store.dispatch(logout());
        window.location.reload();
      }, 1);
      return Promise.reject(error);
    }
    
    // JWT Expired / Malformed / 401 Unauthorized (including SESSION_EXPIRED)
    const errorMsg1 = error.response?.data?.message || '';
    const isAlreadyCreatedErr1 = errorMsg1.toLowerCase().includes('already created') && errorMsg1.toLowerCase().includes('request');
    const isTransactionPasswordErr1 = errorMsg1.toLowerCase().includes('transaction password');
    const isCasinoUrl = originalConfig?.url?.includes('casino') || originalConfig?.url?.includes('Casino');
    
    // ✅ CRITICAL: Don't logout for 500 errors or casino game errors
    const is500Error = error.response?.status === 500;
    const isCasinoGameError = originalConfig?.url?.includes('get-cas-casino-play-url') || 
                               originalConfig?.url?.includes('get-casino-int-games');
    
    if (
      (error.response?.status === 401 ||
      error.response?.data?.message === 'jwt expired' ||
      (error.response?.data?.message === 'jwt malformed' && !originalConfig._retry)) &&
     !isAlreadyCreatedErr1 && !isTransactionPasswordErr1 && !is500Error && !isCasinoGameError
    ) {
      // JWT expired - silently logout without showing error

      const currentPath = window.location.pathname;
      const isAdminPath = currentPath.startsWith('/admin');

      // Clear all tokens
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('token-admin');
      localStorage.removeItem('refreshToken-admin');
      localStorage.removeItem('login-session');

      // ✅ Dispatch logout to clear Redux state
      store.dispatch(logout());

      // ✅ Close any active casino game iframes
      const casinoIframe = document.querySelector('.slot-iframe');
      if (casinoIframe) {
        casinoIframe.classList.remove('show');
      }

      // Redirect to correct login page (silently, no error message)
      setTimeout(() => {
        if (isAdminPath) {
          window.location.href = '/admin/login';
        } else {
          window.location.href = '/login';
        }
      }, 100);

      // ✅ Return a resolved promise with empty data to prevent error propagation
      return Promise.resolve({
        data: { 
          result: [],
          providers: [],
          category: [],
          silentLogout: true
        }
      } as any);
    }

    // ✅ IMPROVED ERROR HANDLING - Show errors to user when needed
    const errorStatus = error.response?.status || 'Network Error';
    const rawErrorMsg = error.response?.data?.message || error.message || 'Unknown error';
    const errorUrl = originalConfig?.url || 'unknown';
    
    // ✅ Map backend error messages to user-friendly messages
    const errorMessageMap: { [key: string]: string } = {
      'User does not exist!': '❌ User not found. Please check your username.',
      'The email or password are incorrect!': '❌ Incorrect password. Please try again.',
      'Your account is deactivated by your parent': '🚫 Account is deactivated. Contact your admin.',
      'Please, send your username and password.': '⚠️ Please enter both username and password.',
      'Demo user not found. Please contact administrator.': '⚠️ Demo login unavailable. Contact support.',
      'Invalid password!': '❌ Invalid password. Please try again.',
      'Transaction Password not matched': '🔐 Transaction password is incorrect.',
      'Confirm Password not matched': '⚠️ Passwords do not match.',
      'Current Password not matched': '❌ Current password is incorrect.',
      'User not found': '❌ User not found.',
    };
    
    // Get user-friendly message or use original
    const errorMsg2 = errorMessageMap[rawErrorMsg] || rawErrorMsg;
    
    // Identify error types
    const isTransactionPasswordErr = rawErrorMsg.toLowerCase().includes('transaction password');
    const isAlreadyCreatedErr = rawErrorMsg.toLowerCase().includes('already created') && rawErrorMsg.toLowerCase().includes('request');
    const isLoginEndpoint = originalConfig?.url?.includes('/login');
    const isRegisterEndpoint = originalConfig?.url?.includes('/register');
    const isUserBalanceEndpoint = originalConfig?.url?.includes('/user-account-balance');
    const isUserWalletEndpoint = originalConfig?.url?.includes('/update-user-wallet');
    const isUserStatusEndpoint = originalConfig?.url?.includes('/update-user-status');
    const isUserUpdateEndpoint = originalConfig?.url?.includes('/update-user');
    const isGeneralSettingEndpoint = originalConfig?.url?.includes('/save-general-setting');
    const isResetPasswordEndpoint = originalConfig?.url?.includes('/reset-transaction-password');
    
    // ✅ Detect specific login/auth errors that MUST be shown
    const isUserNotFoundErr = rawErrorMsg.includes('does not exist') || rawErrorMsg.includes('not found');
    const isPasswordErr = rawErrorMsg.toLowerCase().includes('password') && rawErrorMsg.toLowerCase().includes('incorrect');
    const isDeactivatedErr = rawErrorMsg.toLowerCase().includes('deactivated');
    const isCriticalAuthError = isUserNotFoundErr || isPasswordErr || isDeactivatedErr;
    
    // ✅ SHOW TOAST FOR IMPORTANT ERRORS (Transaction Password, Login, Register, Admin operations)
    const shouldShowToast = isTransactionPasswordErr || 
                           isLoginEndpoint || 
                           isRegisterEndpoint || 
                           isUserBalanceEndpoint ||
                           isUserWalletEndpoint ||
                           isUserStatusEndpoint ||
                           isUserUpdateEndpoint ||
                           isGeneralSettingEndpoint ||
                           isResetPasswordEndpoint ||
                           isCriticalAuthError; // ✅ Always show auth errors
    
    if (shouldShowToast && errorMsg2 && errorMsg2 !== 'No auth token') {
      console.log('🔴 [SHOWING ERROR TO USER]:', errorMsg2);
      setTimeout(() => {
        notifyError(errorMsg2);
      }, 100);
    } else {
      // Log suppressed errors for debugging
      console.log(`🔇 [API ERROR SUPPRESSED] ${errorStatus}: ${errorMsg2} (${errorUrl})`);
    }
    
    // ✅ Return resolved promise with error info
    // Check if this is a network error (no response from server)
    if (!error.response) {
      console.log('🔇 [NETWORK ERROR]:', error.message);
      
      if (isLoginEndpoint || isRegisterEndpoint) {
        setTimeout(() => {
          notifyError('Network error. Please check your connection.');
        }, 100);
      }
      
      return Promise.resolve({
        data: { 
          success: false,
          error: true,
          message: 'Network error. Please check your connection.',
          networkError: true,
          toastShown: shouldShowToast
        }
      } as any);
    }

    // ✅ Handle all HTTP error status codes
    const statusCode = error.response?.status;
    
    return Promise.resolve({
      data: { 
        success: false,
        error: true,
        message: errorMsg2 || `Request failed with status ${statusCode}`,
        statusCode: statusCode,
        toastShown: shouldShowToast
      }
    } as any);
  }
);




export const sportsApi = axios.create({

  baseURL: process.env.REACT_APP_API_SPORTS_URL,

  timeout: 10000,

  headers: {

    'Content-Type': 'application/json',

  },

})



export const fancyApi = axios.create({

  baseURL: process.env.REACT_APP_PYTHON_SERVER,

  timeout: 10000,

  headers: {

    'Content-Type': 'application/json',

  },

})

fancyApi.interceptors.request.use(

  async (config: InternalAxiosRequestConfig) => {

    store.dispatch(setLoader(true))

    // Do something before request is sent

    const token = authService.getToken()

    config.headers.Authorization = token ? `Bearer ${token}` : ''

    // 🔐 AUTO-ENCRYPT BET REQUESTS + mandatory BETCODE for server validation
    // Server (Python/Node) returns 401 "Invalid request. Please use the official betting interface."
    // when betcode is missing or wrong. Encrypted bodies embed betcode inside the ciphertext;
    // unencrypted JSON must send betcode at the top level.
    if (config.url === 'placebet' && config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      const BETCODE = process.env.REACT_APP_BETCODE || 'Yasfdgyys35466'
      const isAlreadyEncrypted = 'payload' in config.data && 'signature' in config.data

      try {
        console.log('🔐 Auto-encrypting bet request...')

        const security = await import('./requestSecurity')
        const userState = store.getState().userReducer
        const userId = userState.userData?.user?._id

        if (userId && !isAlreadyEncrypted) {
          const secureRequest = security.prepareSecureBetRequest(config.data, userId)
          // Top-level betcode for backends that validate before decrypt (e.g. Node fan server)
          config.data = { ...secureRequest, betcode: BETCODE }
          console.log('✅ Bet request encrypted automatically')
          console.log('📦 Encrypted payload sample:', JSON.stringify(config.data).substring(0, 200))
        } else if (!userId && !isAlreadyEncrypted) {
          console.warn('⚠️ No user ID found, sending unencrypted — attaching betcode for server validation')
          config.data = { ...config.data, betcode: BETCODE }
        }
      } catch (error) {
        console.warn('⚠️ Encryption skipped:', error)
        if (!isAlreadyEncrypted && config.data && typeof config.data === 'object') {
          config.data = { ...config.data, betcode: BETCODE }
        }
      }
    }

    return config

  },

  (error: AxiosError) => {

    // Do something with request error

    return Promise.reject(error)

  },

)



// Add a response interceptor

fancyApi.interceptors.response.use(

  (response: AxiosResponse) => {

    store.dispatch(setLoader(false))

    if (!response.data.changePassAndTxn) {

      store.dispatch(setChangePassAndTxn(response.data.changePassAndTxn))

    }



    // Any status code that lie within the range of 2xx cause this function to trigger

    // Do something with response data

    return response

  },

  async (error: AxiosError<{ message: string; data: any }>) => {

    store.dispatch(setLoader(false))

    // Any status codes that falls outside the range of 2xx cause this function to trigger

    // Do something with response error

    const token = authService.getRefreshToken()

    const originalConfig: any = error.config



    if (error.response?.data?.data && error.response?.data?.data.maintenance) {

      setTimeout(() => {

        store.dispatch(logout())

        window.location.reload()

      }, 1)

    }

  const errorMsg3 = error.response?.data?.message || '';
    const isAlreadyCreatedErr3 = errorMsg3.toLowerCase().includes('already created') && errorMsg3.toLowerCase().includes('request');
    const isTransactionPasswordErr3 = errorMsg3.toLowerCase().includes('transaction password');

    if (

       ((error.response?.status === 401 && error.response?.data?.message === 'jwt expired') ||

      (error.response?.data?.message === 'jwt malformed' && !originalConfig._retry)) &&
      
       !isAlreadyCreatedErr3 && !isTransactionPasswordErr3  // Don't logout for "already created request" or "transaction password" errors

    ) {

      // const refreshTokenApi = await authService.refreshToken(token)

      // const accessToken = refreshTokenApi.data.data.newToken

      // originalConfig._retry = true

      // api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

      // localStorage.setItem('token', accessToken)

      // return api(originalConfig)

      store.dispatch(logout())

      window.location.reload()

      return true

    }



    // Only show errors on non-login pages and non-401 errors
    const isLoginPageFancy = window.location.pathname.includes('/login') || window.location.pathname.includes('/dash');
    const is401ErrorFancy = error.response?.status === 401;
    
    // ✅ DON'T show error toast for 401 errors or login pages
    const fancyMsg = error.response?.data?.message
    if (!is401ErrorFancy && !isLoginPageFancy && fancyMsg && fancyMsg !== 'No auth token') {
      notifyError(fancyMsg)
    }
    
     const errorMsg4 = error.response?.data?.message || '';
    const isAlreadyCreatedErr4 = errorMsg4.toLowerCase().includes('already created') && errorMsg4.toLowerCase().includes('request');
      const isTransactionPasswordErr4 = errorMsg4.toLowerCase().includes('transaction password');
    
     if (isAlreadyCreatedErr4 || isTransactionPasswordErr4) {
      // Return a resolved promise to prevent uncaught error
      return Promise.resolve({
        data: { 
          success: false, 
          message: errorMsg4 
        }
      });
    }

    return Promise.reject(error)

  },

)

export default api
